import { environment } from "../../../environments/environment";
import { ChartSelectionCard } from "../Interfaces/chart-selection-card";
import { AppConstants } from "./app-constants";

export class UniqueChart2Constants {
  barChartImgFolderPath: string = "../../../assets/Images/CombinationChart/";
  /*baseUrl: string = environment.baseUrl;*/
  uniqueChartModuleRoutePath = AppConstants.uniqueCategoryPathMap1.chartModuleRoutePath + "/";
  chartDescriptions: any = this.getChartDescriptions();
  uniqueChartModuleComponentPath: string = AppConstants.uniqueCategoryPathMap1.moduleFolderPath;


  //contains the details of all kinds of bar charts that is available in th tool
  uniqueChartTypes: ChartSelectionCard[] = [
    {
      imgUrl: "",
      routePath: this.uniqueChartModuleRoutePath + "funnelchart1Custom",
      routePath2: "",
      description: [],
      chartFolderPath: this.uniqueChartModuleComponentPath + "funnel-chart1",
      chartFolderPath2: "",
      imgClassName: "funnelChartImg",
      chartTitle: "FUNNEL CHART",
      chartId: 1,
      isEnabled: true,
      chartGroup: "Funnel chart"
    },
    // {
    //   "imgUrl": this.barChartImgFolderPath + "02barchart.png",
    //   routePath: this.barChartModuleRoutePath + "BarChart2",
    //   description: this.chartDescriptions.barChart2,
    //   chartFolderPath: this.barChartModuleComponentPath + "barchart2"
    // },
    // {
    //   "imgUrl": this.barChartImgFolderPath + "03barchart.png",
    //   routePath: this.barChartModuleRoutePath + "BarChart3",
    //   description: this.chartDescriptions.genericBarChartDescription,
    //   chartFolderPath: this.barChartModuleComponentPath + "barchart3"
    // },
    // {
    //   "imgUrl": this.barChartImgFolderPath + "04barchart.png",
    //   routePath: this.barChartModuleRoutePath + "BarChart4",
    //   description: this.chartDescriptions.genericBarChartDescription,
    //   chartFolderPath: this.barChartModuleComponentPath + "barchart4"
    // },
    // {
    //   "imgUrl": this.barChartImgFolderPath + "05barchart.png",
    //   routePath: this.barChartModuleRoutePath + "BarChart5",
    //   description: this.chartDescriptions.genericBarChartDescription,
    //   chartFolderPath: this.barChartModuleComponentPath + "barchart5"
    // },
    // {
    //   "imgUrl": this.barChartImgFolderPath + "06barchart.png",
    //   routePath: this.barChartModuleRoutePath + "BarChart6",
    //   description: this.chartDescriptions.genericBarChartDescription,
    //   chartFolderPath: this.barChartModuleComponentPath + "barchart6"
    // },
    // {
    //   "imgUrl": this.barChartImgFolderPath + "07barchart.png",
    //   routePath: this.barChartModuleRoutePath + "BarChart7",
    //   description: this.chartDescriptions.genericBarChartDescription,
    //   chartFolderPath: this.barChartModuleComponentPath + "barchart7"
    // },
    // {
    //   "imgUrl": this.barChartImgFolderPath + "08barchart.png",
    //   routePath: this.barChartModuleRoutePath + "BarChart8",
    //   description: this.chartDescriptions.genericBarChartDescription,
    //   chartFolderPath: this.barChartModuleComponentPath + "barchart8"
    // },
    // {
    //   "imgUrl": this.barChartImgFolderPath + "09barchart.png",
    //   routePath: this.barChartModuleRoutePath + "BarChart9",
    //   description: this.chartDescriptions.genericBarChartDescription,
    //   chartFolderPath: this.barChartModuleComponentPath + "barChart9"
    // },
    // {
    //   "imgUrl": this.barChartImgFolderPath + "10barchart.png",
    //   routePath: this.barChartModuleRoutePath + "BarChart10",
    //   description: this.chartDescriptions.genericBarChartDescription,
    //   chartFolderPath: this.barChartModuleComponentPath + "barChart10"
    // },
    // {
    //   "imgUrl": this.barChartImgFolderPath + "11barchart.png",
    //   routePath: this.barChartModuleRoutePath + "BarChart11",
    //   description: this.chartDescriptions.genericBarChartDescription,
    //   chartFolderPath: this.barChartModuleComponentPath + "barchart11"
    // },
    // {
    //   "imgUrl": this.barChartImgFolderPath + "12barchart.png",
    //   routePath: this.barChartModuleRoutePath + "BarChart12",
    //   description: this.chartDescriptions.genericBarChartDescription,
    //   chartFolderPath: this.barChartModuleComponentPath + "barchart12"
    // },
    // {
    //   "imgUrl": this.barChartImgFolderPath + "13barchart.png",
    //   routePath: this.barChartModuleRoutePath + "BarChart13",
    //   description: this.chartDescriptions.genericBarChartDescription,
    //   chartFolderPath: this.barChartModuleComponentPath + "barchart13"
    // },
  ]

  //Returns the descriptions that has to be displayed in customization section of each bar chart
  getChartDescriptions() {
    let genericDescription = [
      "Bar color could be single solid colour, solid multicolour, linear gradient.",
      "Grid lines in both x-axis and y-axis can be solid, long dash, short dash etc. \
          according to the requirements and can be provided with different styles.",
      "On x-axis text, images can be added."
    ];
    let chartDescription = {
      barChart1: [
        "Colour of the bar can be solid single colour, solid multicolour or linear gradient.",
        "X-axis line can be in solid or any styled format.",
        "Each bar chart can be called out.",
        "Grid lines in y axis can be styled in any way.",
        "Shadow can be applied on the bar.",
        "Data label can be fixed position or absolute position (above each bar chart).In data label \
          you can add text, formatter (text or glyph font icon).",
        "Bar texture (repeated pattern) can be applied."
      ],

      barChart2: [
        ...genericDescription,
        "Data Labels - For the different colour on top of columns formatter is used \
          that returns value as well as the colour from the data."
      ],

      genericBarChartDescription:genericDescription
    }

    return chartDescription;
  }
}
